import { Box, Divider, Toolbar } from '@mui/material';
import React from 'react';

import Footer from 'ui/Footer';

interface IProps {
  children: React.ReactNode;
}

const PageWrapper = ({ children }: IProps) => {
  return (
    <Box>
      <Box margin='30px 0px'>{children}</Box>
      <Box
        sx={{
          // position: 'absolute',
          bottom: 0,
          width: '100%',
          height: '2.5rem',
        }}
      >
        <Divider />
        <Toolbar>
          <Footer />
        </Toolbar>
      </Box>
    </Box>
  );
};

export default PageWrapper;
